<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.shiftNumber" clearable placeholder="编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.shiftName" clearable placeholder="名称" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
      <el-button type="danger" plain :disabled="!selection.length" @click="onDelete()">批量删除</el-button>
    </div>

    <el-table :data="list" border v-loading="loading" @selection-change="selection = $event">
      <el-table-column type="selection" width="48" align="center" />
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="shiftNumber" label="编码" width="120" />
      <el-table-column prop="shiftName" label="名称" min-width="120" show-overflow-tooltip />
      <el-table-column label="默认时段" width="120" align="center">
        <template slot-scope="{ row }">{{ (row.startTime || '') + '-' + (row.endTime || '') }}</template>
      </el-table-column>
      <el-table-column label="周一" width="110" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.mondayWorking === '1' ? (row.mondayHours || '上班') : '休' }}</template>
      </el-table-column>
      <el-table-column label="周五" width="110" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.fridayWorking === '1' ? (row.fridayHours || '上班') : '休' }}</template>
      </el-table-column>
      <el-table-column label="周六" width="80" align="center">
        <template slot-scope="{ row }">{{ row.saturdayWorking === '1' ? '班' : '休' }}</template>
      </el-table-column>
      <el-table-column label="周日" width="80" align="center">
        <template slot-scope="{ row }">{{ row.sundayWorking === '1' ? '班' : '休' }}</template>
      </el-table-column>
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.active === '1'" size="mini" type="success">启用</el-tag>
          <el-tag v-else size="mini" type="info">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.shiftId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.shiftId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="form.shiftId ? '修改班次' : '新增班次'" :visible.sync="visible" width="720px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="编码" prop="shiftNumber">
          <el-input v-model="form.shiftNumber" />
        </el-form-item>
        <el-form-item label="名称" prop="shiftName">
          <el-input v-model="form.shiftName" />
        </el-form-item>
        <el-form-item label="默认起止">
          <el-input v-model="form.startTime" placeholder="HH:mm" style="width:120px" />
          <span style="margin:0 8px">至</span>
          <el-input v-model="form.endTime" placeholder="HH:mm" style="width:120px" />
          <el-button type="text" @click="applyDefaultHours">应用到已勾选工作日</el-button>
        </el-form-item>
        <el-form-item label="周工作日历">
          <el-table :data="weekRows" border size="mini" style="width:100%">
            <el-table-column prop="label" label="星期" width="90" />
            <el-table-column label="上班" width="90" align="center">
              <template slot-scope="s">
                <el-switch v-model="form[s.row.workingKey]" active-value="1" inactive-value="0" />
              </template>
            </el-table-column>
            <el-table-column label="时段（如 06:00-14:00，多段用逗号）">
              <template slot-scope="s">
                <el-input
                  v-model="form[s.row.hoursKey]"
                  size="mini"
                  :disabled="form[s.row.workingKey] !== '1'"
                  placeholder="06:00-14:00"
                />
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.active" active-value="1" inactive-value="0" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listShift, getShift, saveShift, updateShift, deleteShift
} from '../../api/shift'

function emptyForm() {
  return {
    shiftId: '',
    shiftNumber: '',
    shiftName: '',
    active: '1',
    startTime: '08:00',
    endTime: '16:00',
    mondayWorking: '1',
    mondayHours: '08:00-16:00',
    tuesdayWorking: '1',
    tuesdayHours: '08:00-16:00',
    wednesdayWorking: '1',
    wednesdayHours: '08:00-16:00',
    thursdayWorking: '1',
    thursdayHours: '08:00-16:00',
    fridayWorking: '1',
    fridayHours: '08:00-16:00',
    saturdayWorking: '0',
    saturdayHours: '',
    sundayWorking: '0',
    sundayHours: ''
  }
}

export default {
  name: 'MesShiftPage',
  components: { ListPagination },
  data() {
    return {
      query: { shiftNumber: '', shiftName: '' },
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      selection: [],
      visible: false,
      saving: false,
      form: emptyForm(),
      weekRows: [
        { label: '周一', workingKey: 'mondayWorking', hoursKey: 'mondayHours' },
        { label: '周二', workingKey: 'tuesdayWorking', hoursKey: 'tuesdayHours' },
        { label: '周三', workingKey: 'wednesdayWorking', hoursKey: 'wednesdayHours' },
        { label: '周四', workingKey: 'thursdayWorking', hoursKey: 'thursdayHours' },
        { label: '周五', workingKey: 'fridayWorking', hoursKey: 'fridayHours' },
        { label: '周六', workingKey: 'saturdayWorking', hoursKey: 'saturdayHours' },
        { label: '周日', workingKey: 'sundayWorking', hoursKey: 'sundayHours' }
      ],
      rules: {
        shiftNumber: [{ required: true, message: '编码不能为空', trigger: 'blur' }],
        shiftName: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    search() {
      this.page = 1
      this.load()
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    onSize(s) {
      this.pageSize = s
      this.page = 1
      this.load()
    },
    load() {
      this.loading = true
      listShift({
        currentPage: this.page,
        pageSize: this.pageSize,
        shiftNumber: this.query.shiftNumber,
        shiftName: this.query.shiftName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      this.form = emptyForm()
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (!id) return
      getShift(id).then(res => {
        this.form = Object.assign(emptyForm(), res.data || {})
      })
    },
    applyDefaultHours() {
      const h = (this.form.startTime || '') + '-' + (this.form.endTime || '')
      this.weekRows.forEach(r => {
        if (this.form[r.workingKey] === '1') this.form[r.hoursKey] = h
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        const payload = Object.assign({}, this.form)
        const req = payload.shiftId ? updateShift(payload) : saveShift(payload)
        req.then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    onDelete(id) {
      const ids = id ? [id] : this.selection.map(i => i.shiftId)
      if (!ids.length) return
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteShift(ids).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
